export default __webpack_public_path__ + "static/media/icons-menu-entities-active.bea7bc6e.svg";